// extracted by mini-css-extract-plugin
export default {"App":"App_App__2+VHF","App-logo":"App_App-logo__ZBdRO","App-logo-spin":"App_App-logo-spin__t6jjo","container":"App_container__4L7Vo","centerContainer":"App_centerContainer__H+fHX"};